//
import "./app.js"

import "./config/states-config.js";
import "./config/network-config.js";
import "./config/constants-config.js";
import "./config/satellizer-config.js";
import "./config/permissions-config.js";

import "./services/preferences-service.js";
import "./services/entities-service.js";
import "./services/data-service.js";
import "./services/filters-service.js";
import "./services/categories-service.js";
import "./services/districts-service.js";
import "./services/swap-service.js";
import "./services/notification-store.js";
import "./services/objects-service.js";
import "./services/enums-service.js";
import "./services/purchase-service.js";
import "./services/reload-controllers-service.js";
import "./services/affidability-bands-service.js";

import "./filters/swapick-filters.js";

import "./controllers/app-controller.js";
import "./controllers/login-controller.js";
import "./controllers/account-controller.js";
import "./controllers/account-edit-controller.js";
import "./controllers/lost-password-controller.js";
import "./controllers/register-controller.js";
import "./controllers/can-have-controller.js";
import "./controllers/home-controller.js";
import "./controllers/home-categories-controller.js";
import "./controllers/wanted-controller.js";
import "./controllers/owned-controller.js";
import "./controllers/object-controller.js";
import "./controllers/new-object-controller.js";
import "./controllers/swap-controller.js";
import "./controllers/buy-controller.js";
import "./controllers/user-swaps-list-controller.js";

import "./controllers/swaps-list-controller.js";
import "./controllers/worlds-controller.js";
import "./controllers/world-controller.js";
import "./controllers/notifications-controller.js";
import "./controllers/messages-controller.js";
import "./controllers/message-controller.js";
import "./controllers/services-controller.js";
import "./controllers/services-history-controller.js";
import "./controllers/user-info-controller.js";
import "./controllers/help-controller.js";

import "./directives/objects-list.js";
import "./directives/images-gallery.js";
import "./directives/object-feedback.js";
import "./directives/helpers.js";
import "./directives/match.js";



// WEBPACK FOOTER //
// ./src/main.js